// Get routes based on user role
import { isOwnerRole, isStudentRole } from '@utils/routing';
import { ownerRoutes } from './owner.routes';
import { tenantRoutes } from './tenant.routes';
import { studentRoutes } from './student.routes';

/**
 * Gets the appropriate routes based on user role
 * @param {string} role - User's role
 * @returns {Array} Array of route objects
 */
export const getRoutesByRole = (role) => {
    if (isOwnerRole(role)) {
        return ownerRoutes;
    }
    if (isStudentRole(role)) {
        return studentRoutes;
    }
    return tenantRoutes;
};

/**
 * Gets menu items for the sidebar based on user role
 * @param {string} role - User's role
 * @returns {Array} Array of menu item objects
 */
export const getMenuItemsByRole = (role) => {
    // Default to tenant routes if no role (for tenant dashboard)
    const routes = role ? getRoutesByRole(role) : tenantRoutes;
    return routes
        .filter(route => route.menuItem)
        .map(route => route.menuItem);
};


